export default function PageLoading(props) {

  return (
    <div id='page-loading'>
      <p>
        <i className="fas fa-circle-notch fa-spin"></i> Loading...</p>
    </div>
  )
}
